import { BasicTrackingEvent } from "./BasicTrackingEvent";
import * as trackingEvents from "@goodgamestudios/tracking-event-types";

export class ImpressionTrackingEvent extends BasicTrackingEvent {
    public accountId: string;
    public partnerId: string;
    public creative: string;
    public lp: string;
    public placement: string;
    public keyword: string;
    public network: string;
    public channelId: string;
    public trafficSourceId: string;
    public aid: string;
    public camp: string;
    public adgr: string;
    public matchtype: string;
    public journeyHash: string = "";

    constructor(referrer: string) {
        super(referrer);
    }

    public getVars(): trackingEvents.Impression.Event {
        const vars: trackingEvents.Impression.Event = {
            eventId: trackingEvents.Impression.ID,
            accountHash: this.accountId,
            adgr: parseInt(this.adgr),
            aid: parseInt(this.aid),
            camp: parseInt(this.camp),
            cid: this.channelId,
            creative: parseInt(this.creative),
            event_mapping_version: 2,
            journeyHash: parseInt(this.journeyHash),
            keyword: this.keyword,
            lp: parseInt(this.lp),
            matchtype: this.matchtype,
            network: this.network,
            partnerId: parseInt(this.partnerId),
            placement: this.placement,
            tid: this.trafficSourceId,
        };

        return vars;
    }
}
